/**
 * PRE-SALE overlay badge on product cards.
 * Injected only after Globo Pre-Order confirms an active campaign (profile.isPreorder).
 * Matches Wonder .card__badges--item styling; removes itself when the campaign is inactive.
 */
(function () {
  'use strict';

  var CONFIG = window.WTPreSaleBadge || {};
  var LABEL = CONFIG.label || 'PRE-SALE';
  var HIDE_KEYS = (
    CONFIG.hideBadgeKeys || ['sale', 'pre-order', 'preorder', 'pre_order', 'sold-out']
  ).map(function (k) {
    return String(k).toLowerCase();
  });

  var ATTR_BADGE = 'data-pre-sale-badge';
  var ATTR_HIDDEN = 'data-pre-sale-hidden';
  var SCAN_DEBOUNCE_MS = 80;
  var POLL_INTERVAL_MS = 200;
  var POLL_MAX_MS = 15000;

  var scanTimer = null;
  var observer = null;
  var started = false;

  function hasGlobo() {
    return typeof window.Globo !== 'undefined' && window.Globo.Preorder;
  }

  function normalizeId(value) {
    if (value == null || value === '') return '';
    var str = String(value);
    var match = str.match(/(\d+)\s*$/);
    return match ? match[1] : str;
  }

  function getCards(root) {
    var scope = root || document;
    // Limit to product cards that have a badge container (exclude cart/bundle hooks)
    return Array.prototype.slice
      .call(scope.querySelectorAll('[data-product-id]'))
      .filter(function (el) {
        return !!getBadgeContainer(el);
      });
  }

  function getBadgeContainer(card) {
    return (
      card.querySelector('.card__badges') ||
      card.querySelector('.card__picture-container .card__badges')
    );
  }

  function shouldHideBadge(el) {
    if (!el || el.hasAttribute(ATTR_BADGE)) return false;
    var key = (el.getAttribute('data-custom-badge') || '').toLowerCase().trim();
    if (!key) return false;
    return HIDE_KEYS.indexOf(key) !== -1;
  }

  function applyPriority(card, active) {
    var items = card.querySelectorAll('.card__badges--item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!shouldHideBadge(item)) continue;
      if (active) {
        if (!item.hasAttribute(ATTR_HIDDEN)) {
          item.setAttribute(ATTR_HIDDEN, item.style.display || '');
          item.style.display = 'none';
        }
      } else if (item.hasAttribute(ATTR_HIDDEN)) {
        var prev = item.getAttribute(ATTR_HIDDEN);
        item.style.display = prev || '';
        item.removeAttribute(ATTR_HIDDEN);
      }
    }
  }

  function injectBadge(card) {
    var container = getBadgeContainer(card);
    if (!container) return;

    var existing = container.querySelector('[' + ATTR_BADGE + ']');
    if (!existing) {
      var badge = document.createElement('div');
      badge.className = 'card__badges--item';
      badge.setAttribute('data-custom-badge', 'pre-sale');
      badge.setAttribute(ATTR_BADGE, '');
      badge.textContent = LABEL;
      container.insertBefore(badge, container.firstChild);
    }

    applyPriority(card, true);
  }

  function removeBadge(card) {
    var container = getBadgeContainer(card);
    if (container) {
      var badges = container.querySelectorAll('[' + ATTR_BADGE + ']');
      for (var i = 0; i < badges.length; i++) {
        badges[i].remove();
      }
    }
    applyPriority(card, false);
  }

  function findGloboProduct(productId, handle) {
    var products =
      (window.Globo.Preorder.settings && window.Globo.Preorder.settings.products) || [];
    var id = normalizeId(productId);

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p) continue;
      if (normalizeId(p.id) === id) return p;
      if (handle && p.handle && String(p.handle) === String(handle)) return p;
    }
    return null;
  }

  function isActivePreorder(productJson, variantId) {
    if (!productJson || !hasGlobo()) return false;

    try {
      if (typeof window.Globo.Preorder.getResolvedProfile === 'function') {
        var profile = window.Globo.Preorder.getResolvedProfile(
          productJson,
          variantId || (productJson.variants && productJson.variants[0] && productJson.variants[0].id)
        );
        if (profile && profile.isPreorder === true) return true;
        return false;
      }
    } catch (e) {
      /* fall through */
    }

    // Fallback if getResolvedProfile is unavailable: product present in Globo list
    // is not enough alone — only treat as active when an explicit flag exists.
    if (productJson.isPreorder === true) return true;
    if (productJson.preorder === true) return true;
    return false;
  }

  function cardIsActivePreorder(card) {
    if (!hasGlobo()) return false;

    var productId = card.getAttribute('data-product-id');
    var variantId = card.getAttribute('data-variant-id');
    var handle = card.getAttribute('data-product-handle');
    var productJson = findGloboProduct(productId, handle);

    if (!productJson) return false;
    return isActivePreorder(productJson, variantId);
  }

  function syncCard(card) {
    if (!card || !card.getAttribute('data-product-id')) return;
    if (cardIsActivePreorder(card)) {
      injectBadge(card);
    } else {
      removeBadge(card);
    }
  }

  function scan(root) {
    if (!hasGlobo()) return;
    var cards = getCards(root);
    for (var i = 0; i < cards.length; i++) {
      syncCard(cards[i]);
    }
  }

  function scheduleScan(root) {
    if (scanTimer) clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scan(root);
    }, SCAN_DEBOUNCE_MS);
  }

  function reinitCollectionThenScan() {
    try {
      if (hasGlobo() && typeof window.Globo.Preorder.initCollection === 'function') {
        window.Globo.Preorder.initCollection();
      }
    } catch (e) {
      /* ignore */
    }
    scheduleScan();
  }

  function hideGloboBadgeNear(imageWrapper) {
    if (!imageWrapper) return;
    var nodes = imageWrapper.querySelectorAll
      ? imageWrapper.querySelectorAll(
          '[class*="badge"], [class*="Badge"], [data-globo-badge], .globo-preorder-badge, .gpo-badge'
        )
      : [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest && el.closest('.card__badges')) continue;
      if (el.hasAttribute && el.hasAttribute(ATTR_BADGE)) continue;
      el.style.display = 'none';
    }
  }

  function onGloboShowBadge(event) {
    var detail = (event && event.detail) || {};
    var imageWrapper = detail.imageWrapper;
    if (!imageWrapper) return;

    hideGloboBadgeNear(imageWrapper);

    var card =
      (imageWrapper.closest && imageWrapper.closest('[data-product-id]')) ||
      (imageWrapper.parentElement &&
        imageWrapper.parentElement.closest &&
        imageWrapper.parentElement.closest('[data-product-id]'));

    if (card) {
      // Only inject when Globo profile confirms active pre-order
      syncCard(card);
    } else {
      scheduleScan();
    }
  }

  function observeGrids() {
    if (observer) return;
    observer = new MutationObserver(function (mutations) {
      var needsScan = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) {
          needsScan = true;
          break;
        }
      }
      if (needsScan) scheduleScan();
    });

    var targets = document.querySelectorAll(
      '#ProductGridContainer, .product-grid, [data-product-grid], .collection, main'
    );
    if (!targets.length) {
      observer.observe(document.body, { childList: true, subtree: true });
      return;
    }
    for (var t = 0; t < targets.length; t++) {
      observer.observe(targets[t], { childList: true, subtree: true });
    }
  }

  function bindEvents() {
    document.addEventListener('facets:change', function () {
      reinitCollectionThenScan();
    });

    document.addEventListener('globo.preorder.show.badge', onGloboShowBadge);

    window.addEventListener('preorderRendered', function () {
      scheduleScan();
    });
  }

  function waitForGlobo(callback) {
    if (hasGlobo()) {
      callback();
      return;
    }

    var elapsed = 0;
    var interval = setInterval(function () {
      elapsed += POLL_INTERVAL_MS;
      if (hasGlobo()) {
        clearInterval(interval);
        callback();
      } else if (elapsed >= POLL_MAX_MS) {
        clearInterval(interval);
      }
    }, POLL_INTERVAL_MS);

    window.addEventListener(
      'preorderRendered',
      function onReady() {
        clearInterval(interval);
        window.removeEventListener('preorderRendered', onReady);
        callback();
      },
      { once: true }
    );
  }

  function start() {
    if (started) return;
    started = true;
    bindEvents();
    observeGrids();
    scheduleScan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForGlobo(start);
    });
  } else {
    waitForGlobo(start);
  }
})();
